export default __webpack_public_path__ + "static/media/hogwarts-coat-of-arms.df338404.png";